import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject, of, throwError } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppService } from "../app.service";
import * as web_data from "../../assets/web-sites.json";
import { catchError, map, retry, take } from "rxjs/operators";
import { stateRequest } from "./models/enum";
import { environment } from "src/environments/environment";
import { BaseService } from "./services/base.service";
import { LinkTransformPipe } from "./pipes/affiliates.pipe";
import { Link } from "./models/model";
import { blockEditorFileUpload } from "@app/shared/enum/files-path-upload.enum";
import { AWSS3Service } from "@app/shared/service/awsS3.service";
import { ResourcesService } from "./components/resources/services/resources.service";
import { TrainingService } from "./services/training.service";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class AffiliatesService extends BaseService {
  public showModal: Boolean = false;
  public hiddenModal: Boolean = false;
  public token: string;

  public loading: Boolean = true;

  constructor(
    http: HttpClient,
    _appService: AppService,
    private _awsS3Service: AWSS3Service,
    private _resourcesService: ResourcesService,
    private _trainService: TrainingService,
    private _translate: TranslateService,
  ) {
    super(http, _appService);
  }

  section = "promocionar";

  baseRetry: number = 0;

  baseLambdaUrl = environment.urlAPI;
  baseLambdaAfiliatesUrl = environment.urlAPIAffiliate;

  public promociones: any = [];
  public _infoLinksObservable = new BehaviorSubject<any>(null);
  public executiongetlinks: number = -1;
  public loadingLinks: Boolean = false;
  public selectedPromo: any = null;
  public linkLEK: any = null;
  public loadingMoreLinks: Boolean = false;

  public orderBy: string = "paid";
  public order: "DESC" | "ASC" = "DESC";

  public top_promotions: any = [];
  public loadingTopPromotions: boolean = false;
  public loadingMoreTopPromotions: boolean = false;
  public topPromotionsLEK: any = null;
  public executiongetTopPromotions: number = -1;

  // GETS
  getLinks(
    businessId: string,
    options?: { orderBy?: string; order?: string; initial?: boolean },
  ): Observable<any> {
    this.loadingLinks = true;
    let URL = this.baseLambdaAfiliatesUrl + `/business/"${businessId}"/links`;

    const { orderBy, order, initial } = options || {};

    let params = new URLSearchParams();

    // En caso de que se mande un request inicial (con valores por defecto)
    if (initial) {
      params.set("order_by", JSON.stringify(this.orderBy));
      params.set("order", JSON.stringify(this.order));
      URL += `?${params.toString()}`;
    }

    // En caso de que se mande un request con qParams dinámicos
    if (orderBy && order) {
      params.set("order_by", JSON.stringify(orderBy));
      params.set("order", JSON.stringify(order));

      URL += `?${params.toString()}`;
    }

    return this.get(URL).pipe(
      map((response: any) => {
        const status = response?.status;
        const data = response?.data;
        const LEK = response?.LastEvaluatedKey;

        if (status) {
          const linkPipe = new LinkTransformPipe();
          this.promociones = linkPipe.transform(data, this.setNames);
          this._infoLinksObservable.next(this.promociones);

          this.deleteRepeatedLists();

          this.linkLEK = LEK;
          this.executiongetlinks = stateRequest.excuted;
        } else {
          this.executiongetlinks = stateRequest.error;
        }
        this.loadingLinks = false;
        return {
          valid: true,
          print: data || [],
          message: response?.errorMessage,
        };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getUsers", [])),
    );
  }

  /**
   *
   * @param businessId recibe business_id
   * @returns retorna un observable con el response
   */
  getMoreLinks(
    businessId: string,
    orderBy?: string,
    order?: string,
  ): Observable<any> {
    this.loadingMoreLinks = true;

    // Construimos parámetros para la busqueda
    const params = new URLSearchParams();
    params.set("LastEvaluatedKey", JSON.stringify(this.linkLEK));

    if (orderBy && order) {
      params.set("order_by", JSON.stringify(orderBy));
      params.set("order", JSON.stringify(order));
    }

    return this.get(
      this.baseLambdaAfiliatesUrl + `/business/"${businessId}"/links?${params}`,
    ).pipe(
      map((response: any) => {
        // Aseguramos variables devueltas por el backend
        const status = response?.status;
        const data = response?.data;
        const LEK = response?.LastEvaluatedKey;

        if (status) {
          const linkPipe = new LinkTransformPipe();
          const newData = linkPipe.transform(data, this.setNames);

          this.promociones = [...this.promociones, ...newData];

          this.deleteRepeatedLists();
          this._infoLinksObservable.next(this.promociones);
          this.linkLEK = LEK;
        } else {
          this.linkLEK = LEK;
        }
        this.loadingMoreLinks = false;
        return { valid: true, print: this.promociones };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getUsers", [])),
    );
  }

  getTopPromotions(
    businessId: string,
    querys?: { orderBy?: string; order?: string; initial?: boolean },
  ): Observable<any> {
    this.loadingTopPromotions = true;
    let URL = this.baseLambdaAfiliatesUrl + `/business/"${businessId}"/links`;

    const { orderBy, order, initial } = querys || {};

    let params = new URLSearchParams();

    // En caso de que se mande un request inicial (con valores por defecto)
    if (initial) {
      params.set("order_by", JSON.stringify(this.orderBy));
      params.set("order", JSON.stringify(this.order));
      URL += `?${params.toString()}`;
    }

    // En caso de que se mande un request con qParams dinámicos
    if (orderBy && order) {
      params.set("order_by", JSON.stringify(orderBy));
      params.set("order", JSON.stringify(order));

      URL += `?${params.toString()}`;
    }

    return this.get(URL).pipe(
      map((response: any) => {
        const status = response?.status;
        const data = response?.data;
        const LEK = response?.LastEvaluatedKey;

        if (status) {
          const linkPipe = new LinkTransformPipe();
          this.top_promotions = linkPipe.transform(data, this.setNames);

          // this.deleteRepeatedLists();
          this.topPromotionsLEK = LEK;
          this.executiongetTopPromotions = stateRequest.excuted;
        } else {
          this.executiongetTopPromotions = stateRequest.error;
        }
        this.loadingTopPromotions = false;
        return {
          valid: true,
          print: data || [],
          message: response?.errorMessage,
        };
      }),
      retry(this.baseRetry),
      catchError((error) => {
        this.loadingTopPromotions = false;
        this.executiongetTopPromotions = stateRequest.error;

        return throwError(() => error);
      }),
    );
  }

  getMoreTopPromotions(
    businessId: string,
    orderBy?: string,
    order?: string,
  ): Observable<any> {
    this.loadingMoreTopPromotions = true;

    // Construimos parámetros para la busqueda
    const params = new URLSearchParams();
    params.set("LastEvaluatedKey", JSON.stringify(this.topPromotionsLEK));

    if (orderBy && order) {
      params.set("order_by", JSON.stringify(orderBy));
      params.set("order", JSON.stringify(order));
    }

    return this.get(
      this.baseLambdaAfiliatesUrl + `/business/"${businessId}"/links?${params}`,
    ).pipe(
      map((response: any) => {
        // Aseguramos variables devueltas por el backend
        const status = response?.status;
        const data = response?.data;
        const LEK = response?.LastEvaluatedKey;

        if (status) {
          const linkPipe = new LinkTransformPipe();
          const newData = linkPipe.transform(data, this.setNames);

          this.top_promotions = [...this.top_promotions, ...newData];

          this.topPromotionsLEK = LEK;
        } else {
          this.topPromotionsLEK = LEK;
        }
        this.loadingMoreTopPromotions = false;
        return { valid: true, print: this.top_promotions };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getUsers", [])),
    );
  }

  orderLinksByKey(orderKey?: string, order: "ASC" | "DESC" = "DESC") {
    if (!orderKey) return;

    this.promociones = [...this.promociones].sort((a, b) => {
      const valueA = a[orderKey];
      const valueB = b[orderKey];

      if (valueA === valueB) return 0;

      if (order === "ASC") {
        return valueA < valueB ? -1 : 1;
      } else {
        return valueA > valueB ? -1 : 1;
      }
    });
  }

  getResultLinks(text, businessId): Observable<any> {
    let url =
      this.baseLambdaAfiliatesUrl +
      `/business/"${businessId}"/links?q=${JSON.stringify(text)}`;
    return this.get(url).pipe(
      map((response: any) => {
        if (response.status) {
          const linkPipe = new LinkTransformPipe();
          return {
            valid: true,
            print: linkPipe.transform(response.links, this.setNames),
            last_item: response.last_item,
            total_campaigns: response.total_hits,
          };
        } else {
          return { valid: false, print: "not found" };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getResultSearch", [])),
    );
  }

  getLink(businessId: string, linkId: string): Observable<any> {
    return this.get(
      this.baseLambdaAfiliatesUrl +
        `/business/"${businessId}"/links?link_id="${linkId}"`,
    ).pipe(
      map((response: any) => {
        if (response.status) {
          return { valid: true, print: response.data || [] };
        } else {
          return { valid: false, print: [] };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getLink", [])),
    );
  }

  /**
   * @param id id del link
   * @param changes objecto con propiedades para hacer PUT
   *
   * Actualiza una propiedad específica de un link dentro de:
   *
   *  1. _infoLinksObservable: Behavior que contiene lista principal de links (sin filtrar)
   *  2. filteredLinks:        Lista general de campañas filtradas
   *
   * La función principal de este método es mantener un equilibrio entre ambas listas
   */
  updateLinkData(id: number | string, changes: Partial<any>) {
    const links = this._infoLinksObservable.getValue();
    if (!Array.isArray(links)) return;

    const timestamp = new Date();

    // Buscar primero en los links principales
    let index = links.findIndex((link) => link?.id == id);
    let targetArray = links;

    // Si no está ahí, buscar en los filtrados
    if (index === -1) {
      index = this.filteredLinks?.findIndex((link) => link?.id == id) ?? -1;
      targetArray = this.filteredLinks ?? [];
    }

    // Si no se encuentra en ningún lado, no hacemos nada
    if (index === -1) return;

    const updatedLink = {
      ...targetArray[index],
      ...changes,
      status_last_update: timestamp,
      last_update: timestamp,
    };

    const updatedArray = targetArray.map((link, i) =>
      i === index ? updatedLink : link,
    );

    // Actualizar donde corresponda
    if (targetArray === links) {
      this._infoLinksObservable.next(updatedArray);
    } else {
      this.filteredLinks = updatedArray;
    }

    // Sincronizar en ambos conjuntos ya que el link está en ambos
    this.promociones =
      this.promociones?.map((link) => (link.id == id ? updatedLink : link)) ??
      this.promociones;
    this.filteredLinks =
      this.filteredLinks?.map((link) => (link.id == id ? updatedLink : link)) ??
      this.filteredLinks;

    this._infoLinksObservable.next(
      links.map((link) => (link.id == id ? updatedLink : link)),
    );

    return updatedLink;
  }

  // [OFFERS DEPRECATED] Kept as empty stubs so consumers don't break during gradual removal
  public ofertas: any[] = [];
  public _infoOffersObservable = new BehaviorSubject<any>([]);
  public executiongetoffers: number = 1; // pretend already executed
  public loadingOffers: Boolean = false;
  public canGetOffers: Boolean = false;
  public loadingMoreOffers: Boolean = false;

  /** @deprecated Offers no longer used commercially */
  getOffers(): Observable<any> {
    return of({ valid: true, print: [] });
  }

  /** @deprecated Offers no longer used commercially */
  getMoreOffers(): Observable<any> {
    return of({ valid: true, print: [] });
  }

  // POSTS
  postLinks(businessId: string, data): Observable<Object> {
    return this.post(
      this.baseLambdaAfiliatesUrl + `/business/"${businessId}"/links`,
      data,
    ).pipe(
      map((response: any) => {
        if (response.status) {
          //this.promociones.push(response.data);
          return {
            valid: true,
            print: response.data,
            created: response.created,
          };
        } else {
          return { valid: false, print: response.data };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getUsers", [])),
    );
  }

  // PUTS
  putLinks(businessId: string, id: string, data: any): Observable<any> {
    const url = `${this.baseLambdaAfiliatesUrl}/business/"${businessId}"/links/${id}`;
    return this.put(url, data).pipe(
      map((response: any) => {
        return { valid: response?.status || false, print: response?.data };
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("updateDepartament", [])),
    );
  }

  // DELETES
  deleteLink(businessId: string, id: string): Observable<any> {
    const url = `${this.baseLambdaAfiliatesUrl}/business/"${businessId}"/links/${id}`;
    return this.delete(url).pipe(
      map((response: any) => {
        // Validar datos
        if (response.status) {
          return { valid: true };
        } else {
          return { valid: false, print: response.errorMessage };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("LinksDelete", [])),
    );
  }

  public filteredLinks: any = []; // Nueva variable para almacenar promociones filtradas
  public _filteredInfoLinksObservable = new BehaviorSubject<any>(null); // Nuevo observable para las promociones filtradas
  public pageFilteredLinks: number = 0; // Nueva variable para la paginación de promociones filtradas
  public filterActive: boolean = false;
  public loadingFilteredLinks: boolean = false;
  public canGetFilteredLinks: boolean = false;
  public filterParams;
  public filterTypes: Object = {};
  public LEK_FILTER: any;
  public totalCampaigns: number;
  // GETS
  /**
   *
   * @param businessId
   * @param query
   * @param isPaginating
   * @returns
   */
  getFilteredLinks(
    businessId: string,
    query: string | number,
    isPaginating: boolean = false,
  ): Observable<{ valid: boolean; print: any[] }> {
    const isNewQuery = query != this.filterParams;

    if (isNewQuery || !isPaginating) {
      this.filteredLinks = [];
      this.LEK_FILTER = null;
      this.totalCampaigns = 0;
    }

    this.filterParams = query;
    this.loadingFilteredLinks = true;

    const params = new URLSearchParams();
    const isNumericQuery = typeof query === "number";

    if (isNumericQuery) {
      params.set("id", JSON.stringify(query.toString()));
    } else {
      params.set("q", JSON.stringify(query));
    }

    if (
      isPaginating &&
      this.LEK_FILTER &&
      Object.keys(this.LEK_FILTER).length > 0
    ) {
      params.set("last_item", JSON.stringify(this.LEK_FILTER));
    }

    const url = `${this.baseLambdaAfiliatesUrl}/business/${JSON.stringify(
      businessId,
    )}/links?${params.toString()}`;

    return this.get(url).pipe(
      retry(this.baseRetry),
      map((response: any) => {
        this.loadingFilteredLinks = false;

        if (!response?.status || !response?.data) {
          this.filterActive = true;

          // Solo ponemos 0 si es la primera búsqueda
          if (!isPaginating) this.totalCampaigns = 0;
          return { valid: false, print: [] };
        }

        const totalHits = Number(response.total_hits);
        let linksData: any = response.data.links ?? response.data ?? [];

        if (!Array.isArray(linksData)) {
          linksData = Object.keys(linksData).length > 0 ? [linksData] : [];
        }

        // Mantiene total anterior si es paginación y el backend responde vacío
        if (!isPaginating) {
          if (!isNaN(totalHits) && totalHits > 0) {
            this.totalCampaigns = totalHits;
          } else if (linksData.length === 0 && !isNumericQuery) {
            this.totalCampaigns = 0;
          } else if (isNumericQuery) {
            this.totalCampaigns = 1;
          }
        } else {
          // En paginación, solo actualiza si viene un total válido
          if (!isNaN(totalHits) && totalHits > 0) {
            this.totalCampaigns = totalHits;
          }
          // Si totalHits es 0 o no existe -> mantenemos el anterior
        }

        const linkPipe = new LinkTransformPipe();
        const transformedLinks = linkPipe.transform(linksData, this.setNames);

        const uniqueLinks = [...this.filteredLinks, ...transformedLinks].filter(
          (link, index, arr) => index == arr.findIndex((l) => l.id == link.id),
        );

        this.filteredLinks = isPaginating ? uniqueLinks : transformedLinks;

        // Si no encontró nada, buscar localmente en el observable
        if (this.filteredLinks.length === 0) {
          const localLinks = this._infoLinksObservable.getValue() ?? [];

          // Buscar coincidencias locales (por id o por nombre)
          this.filteredLinks = localLinks.filter((link) => {
            if (isNumericQuery) return link.id == query;
            return link.name
              ?.toLowerCase()
              .includes(String(query).toLowerCase());
          });

          this.totalCampaigns = this.filteredLinks.length;
        }

        this._filteredInfoLinksObservable.next(this.filteredLinks);
        this.setNamesList(true);

        this.filterActive = true;
        this.LEK_FILTER = response.data.last_item ?? null;

        return { valid: true, print: transformedLinks };
      }),
      catchError((error) => {
        this.loadingFilteredLinks = false;
        this.filterActive = true;
        // Solo resetea total si no estamos paginando
        if (!isPaginating) this.totalCampaigns = 0;
        this.handleError<any>("getFilteredLinks", [])(error);
        return of({ valid: false, print: [] });
      }),
    );
  }

  public searchedLinks: any[] = [];
  public _searchedInfoLinksObservable = new BehaviorSubject<any>(null);
  public pageSearchedLinks: number = 0;
  public searchActive: boolean = false;
  public loadingSearchedLinks: boolean = false;
  public canGetSearchedLinks: boolean = false;
  public searchParams: string | number;
  public LEK_SEARCH: any;
  public totalSearchedLinks: number;
  getSearchedLinks(
    businessId: string,
    query: string | number,
    isPaginating: boolean = false,
  ): Observable<{ valid: boolean; print: any[] }> {
    const isNewQuery = query != this.searchParams;

    if (isNewQuery || !isPaginating) {
      this.searchedLinks = [];
      this.LEK_SEARCH = null;
      this.searchActive = false;
      this.totalSearchedLinks = 0;
    }

    this.searchParams = query;
    this.loadingSearchedLinks = true;

    const params = new URLSearchParams();
    const isNumericQuery = typeof query === "number";

    if (isNumericQuery) {
      params.set("id", JSON.stringify(query.toString()));
    } else {
      params.set("q", JSON.stringify(query));
    }

    if (
      isPaginating &&
      this.LEK_SEARCH &&
      Object.keys(this.LEK_SEARCH).length > 0
    ) {
      params.set("last_item", JSON.stringify(this.LEK_SEARCH));
    }

    const url = `${this.baseLambdaAfiliatesUrl}/business/${JSON.stringify(
      businessId,
    )}/links?${params.toString()}`;

    return this.get(url).pipe(
      retry(this.baseRetry),
      map((response: any) => {
        this.loadingSearchedLinks = false;

        if (!response?.status || !response?.data) {
          this.searchActive = true;
          if (!isPaginating) this.totalSearchedLinks = 0;
          return { valid: false, print: [] };
        }

        const totalHits = Number(response.data.total_hits);
        let linksData: any = response.data.links ?? response.data ?? [];

        if (!Array.isArray(linksData)) {
          linksData = Object.keys(linksData).length > 0 ? [linksData] : [];
        }

        if (!isPaginating) {
          if (!isNaN(totalHits) && totalHits > 0) {
            this.totalSearchedLinks = totalHits;
          } else if (linksData.length === 0 && !isNumericQuery) {
            this.totalSearchedLinks = 0;
          } else if (isNumericQuery) {
            this.totalSearchedLinks = 1;
          }
        } else {
          if (!isNaN(totalHits) && totalHits > 0) {
            this.totalSearchedLinks = totalHits;
          }
        }

        const linkPipe = new LinkTransformPipe();
        const transformedLinks = linkPipe.transform(linksData, this.setNames);

        const uniqueLinks = [...this.searchedLinks, ...transformedLinks].filter(
          (link, index, arr) =>
            index === arr.findIndex((l) => l.id === link.id),
        );

        this.searchedLinks = isPaginating ? uniqueLinks : transformedLinks;

        if (this.searchedLinks.length === 0) {
          const localLinks = this._infoLinksObservable.getValue() ?? [];

          this.searchedLinks = localLinks.filter((link) => {
            if (isNumericQuery) return link.id == query;
            return link.name
              ?.toLowerCase()
              .includes(String(query).toLowerCase());
          });

          this.totalSearchedLinks = this.searchedLinks.length;
        }

        this._searchedInfoLinksObservable.next(this.searchedLinks);

        this.searchActive = true;
        this.LEK_SEARCH = response.data.last_item ?? null;

        return { valid: true, print: transformedLinks };
      }),
      catchError((error) => {
        this.loadingSearchedLinks = false;
        this.searchActive = true;
        if (!isPaginating) this.totalSearchedLinks = 0;
        this.handleError<any>("getSearchedLinks", [])(error);
        return of({ valid: false, print: [] });
      }),
    );
  }

  cleanFilteredLinks() {
    this.filteredLinks = [];
    this._filteredInfoLinksObservable.next(null);
    this.pageFilteredLinks = 0;
    this.canGetFilteredLinks = false;
    this.loadingFilteredLinks = false;
    this.filterActive = false;
  }

  // countryDiscount: any;
  // countryId: any;
  // getCountries(id: string): Observable<any> {
  //   const url = `${this.baseLambdaUrl}/countries/"${id}"/value`;
  //   return this.get(url).pipe(
  //     map((response: any) => {
  //       this.countryDiscount = response.data[0].Country.discount;
  //       this.countryId = response.data[0].Country.id;
  //       return { valid: response.status, print: response.data };
  //     }),
  //     retry(this.baseRetry),
  //     catchError(this.handleError<any>("getCountries", []))
  //   );
  // }

  cleanAffiliates() {
    //reset variables
    this.promociones = [];
    this._infoLinksObservable.next(null);
    this.executiongetlinks = -1;
    this.loadingLinks = false;
    this.selectedPromo = null;
    this.linkLEK = null;
    this.loadingMoreLinks = false;

    // [OFFERS DEPRECATED] No longer needed
  }

  setNamesList(isFilter: boolean = false) {
    const links = isFilter ? this.filteredLinks : this.promociones;
    links.forEach((link, index) => {
      if (!link?.name) {
        links[index].name = this.setNames(link);
        links[index].isDerivedName = true;
      }
      if (!link?.mediaContent) {
        links[index].mediaContent = {
          id: link.product_id,
          type: link.type,
          image_web: link.product?.image_web,
        };
      }
    });
  }

  setNames = (promocion: any): string => {
    if (promocion?.type === "business")
      return this._translate.instant("PAGE_ALIASES.BUSINESS_LINK");

    if (promocion?.name) return promocion.name;

    let tempName = promocion?.URL || promocion?.url;

    if (!tempName) return this._translate.instant("PAGE_ALIASES.NO_NAME");

    const cleanPath = this.extractPath(tempName);

    if (!tempName.includes("https://edutin.com/")) {
      return tempName;
    }

    let section_name = cleanPath.split("-");

    if (promocion.type == "category")
      section_name.splice(section_name.length - 1, 1);
    else if (
      promocion.type == "courses" &&
      parseInt(section_name[section_name.length - 1]) == promocion.product_id
    )
      section_name.splice(section_name.length - 1, 1);
    else if (
      promocion.type == "home" ||
      promocion.type == "info" ||
      promocion.type == "website"
    )
      section_name = [""];

    let name = "";
    //console.log("section_name", section_name)

    if (section_name.length > 1) {
      section_name.forEach((section, i) => {
        if (i == 0) {
          section = section[0].toUpperCase() + section.slice(1);
        }
        name += section + " ";
      });
    } else {
      switch (cleanPath) {
        case "":
          name = this._translate.instant("PAGE_ALIASES.HOME");
          break;
        case "about-us":
          name = this._translate.instant("PAGE_ALIASES.ABOUT");
          break;
        case "history":
          name = this._translate.instant("PAGE_ALIASES.HISTORY");
          break;
        case "virtual-campus":
          name = this._translate.instant("PAGE_ALIASES.VIRTUAL_CAMPUS");
          break;
        case "academy-contents":
          name = this._translate.instant("PAGE_ALIASES.ACADEMIC_CONTENT");
          break;
        case "helps/home":
          name = this._translate.instant("PAGE_ALIASES.HELP");
          break;
        case "como-creamos-nuestros-cursos":
          name = this._translate.instant("PAGE_ALIASES.HOW_WE_CREATE_COURSES");
          break;
      }
    }
    //console.log("name", name)
    return name;
  };

  private extractPath(url: string): string {
    if (!url) return "";

    const base = "https://edutin.com/";
    if (!url.includes(base)) return url;

    let path = url.split(base)[1] || "";

    const segments = path.split("/");

    const langPrefixes = Object.values(this._appService.languages_links)
      .map((l) => l.code)
      .filter(Boolean);

    if (langPrefixes.includes(segments[0])) {
      segments.shift();
    }

    return segments.join("/");
  }

  getLinkShared(id: any): string {
    return environment.mainDomain + "/sh-" + id;
  }

  getEmbed(businessId: any, id: any, type: string): string {
    let text = `<iframe height="${
      type == "link" ? "345" : "493"
    }" width="100%" src="${
      environment.appDomain
    }/embeds/lists?business=${businessId}&id=${id}&type=${type}" frameborder="0" allowfullscreen title="Edutin"></iframe>`;
    return text;
  }

  public stateGetCampaigns: stateRequest = stateRequest.notExcuted;
  public infoCampaigns: any = [];
  public _infoCampaignsObservable: Subject<any[]> = new Subject<any[]>();
  public loadingCampaigns: Boolean = false;
  public executiongetCampaigns: number = -1;

  getCampaings(): Observable<any> {
    return this.get(this.baseLambdaAfiliatesUrl + "/categories").pipe(
      map((response: any) => {
        if (response.status) {
          this.infoCampaigns = response.data;
          this._infoCampaignsObservable.next(response.data);
          this.executiongetCampaigns = 1;
          return { valid: true, print: response.data };
        } else {
          this.executiongetCampaigns = 0;
          return { valid: false, print: [] };
        }
      }),
      retry(this.baseRetry),
      catchError(this.handleError<any>("getCampaings", [])),
    );
  }

  deleteRepeatedLists(): void {
    let lists = [];
    this.promociones.forEach((list) => {
      if (lists.findIndex((l) => l.id == list.id) == -1) {
        lists.push(list);
      }
    });
    this.promociones = lists;
  }

  public getWebSites() {
    let web: any = (web_data as any).default;

    let webSites = [];

    let array_ = [];
    web.forEach((element, index) => {
      if (index == web.length - 1) {
        webSites = web.concat(array_);
      }
    });

    return webSites;
  }

  uploadFile(file: File, pathType: blockEditorFileUpload, data: any) {
    let path = this.getPathFiles(pathType, data);
    return new Promise((resolve, reject) => {
      let file_ext = file.name.split(".").pop();
      let file_name;
      let bucket = {
        name: "edutin-publico",
        path: path,
      };
      if (file.size / 1024 / 1024 > 30) {
        reject(new Error(this._translate.instant("RESOURCES.FILE_TOO_LARGE")));
        return;
      }

      //valida que el size del file sea <= 250
      file_name = `${new Date().getTime()}-archivo.${file_ext}`;

      let folderKey = `${bucket.path}/`;

      let url = `${window.btoa(bucket.name)}/${window.btoa(
        folderKey + file_name,
      )}`;
      let fullPath = bucket.path + "/" + file_name;
      let send = {
        bucket: bucket.name,
        key: folderKey + file_name,
      };

      this._awsS3Service
        .generate_url(url, send, file)
        .subscribe((response: any) => {
          const { data, status } = response;
          if (status) {
            resolve({ data, fullPath });
          } else {
            reject(new Error("Error al subir el archivo"));
          }
        });
    });
  }

  //resources_assets/{resource_id}/blocknote/file.ext

  getPathFiles(pathType: blockEditorFileUpload, data?: any) {
    switch (pathType) {
      case blockEditorFileUpload.resource_media:
        return (
          "resources_assets/" +
          this._resourcesService.currentResource.id +
          "/blocknote"
        );
    }
  }
}
